import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteWelfareTreatmentApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-welfare-treatment'
  }
}